import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormComponent } from './components/form/form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from '../util/material/material.module';
import { FormDateComponent } from './components/form-date/form-date.component';
import { FormInputComponent } from './components/form-input/form-input.component';
import { FormSelectComponent } from './components/form-select/form-select.component';
import { FormRadioButtonComponent } from './components/form-radio-button/form-radio-button.component';
import { FormCheckboxComponent } from './components/form-checkbox/form-checkbox.component';
import { FormFieldDirective } from './directives/form-field.directive';
import { FormButtonComponent } from './components/form-button/form-button.component';
import { FormGroupComponent } from './components/form-group/form-group.component';
import { NgxMaskModule } from 'ngx-mask';
import { FormTemplateDirective } from './directives/form-template.directive';
import { FormAccordionComponent } from './templates/form-accordion/form-accordion.component';
import { FormGridComponent } from './templates/form-grid/form-grid.component';
import { FormInlineComponent } from './templates/form-inline/form-inline.component';
import { EnableControlModule } from '../util/material/directives/enabled-controls.directive';
import { FormLabelComponent } from './components/form-label/form-label.component';
import { FormService } from './services/form.service';
import { FormDateRangeComponent } from './components/form-date-range/form-date-range.component';
import { FormFileUploadComponent } from './components/form-file-upload/form-file-upload.component';
import { FormControlsContainerComponent } from './components/form-controls-container/form-controls-container.component';
import { FormSlideToggleComponent } from './components/form-slide-toggle/form-slide-toggle.component';
import { FormSliderComponent } from './components/form-slider/form-slider.component';
import { NgxCurrencyModule } from 'ngx-currency';
import { GioPipesModule } from '../../pipes/gio-pipes.module';
import { FormInjectComponent } from './components/form-inject/form-inject.component';
import { FormInjectDirective } from './directives/form-inject.directive';
import { GioDateMaskDirective } from './directives/gio-date-mask.directive';
import { FormFieldService } from './services/form-field.service';
import { FormEntityComponent } from './components/form-entity/form-entity.component';
import { EntitySearchModalModule } from 'src/app/features/entity/modals/entity-search-modal/entity-search-modal.module';
import { FormBaseComponent } from './models/form-base-component';
import { FormListPickerComponent } from './components/form-list-picker/form-list-picker.component';
import { FormChipsComponent } from './components/form-chips/form-chips.component';
import { FormColorComponent } from './components/form-color/form-color.component';
import { CustomColorModule } from '../form-custom-fields/custom-color/custom-color.module';

@NgModule({
  declarations: [

    // Components
    FormButtonComponent,
    FormComponent,
    FormInputComponent,
    FormInputComponent,
    FormSelectComponent,
    FormDateComponent,
    FormRadioButtonComponent,
    FormCheckboxComponent,
    FormGroupComponent,
    FormSlideToggleComponent,
    FormLabelComponent,
    FormDateRangeComponent,
    FormFileUploadComponent,
    FormControlsContainerComponent,
    FormInjectComponent,
    FormSliderComponent,
    FormEntityComponent,
    FormListPickerComponent,
    FormChipsComponent,
    FormColorComponent,

    // Templates
    FormBaseComponent,
    FormAccordionComponent,
    FormGridComponent,
    FormInlineComponent,

    // Directives
    FormTemplateDirective,
    FormFieldDirective,
    GioDateMaskDirective,
    FormInjectDirective

  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule,
    NgxCurrencyModule,
    EnableControlModule,
    GioPipesModule,
    EntitySearchModalModule,
    CustomColorModule
  ],
  exports: [
    FormComponent,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    FormService,
    FormFieldService
  ]
})
export class FormModule { }
